import { useQuery } from "react-query"

import { api } from "../services/axios"

export const useGetUserOPti = (email) => {
  return useQuery([{ email }],
    async () => {
      const { data, status } = await api.get(`usuarios/${email}/login`)
      return { data, status }
    }
  )
}

export const useGetUsuario = (id) => {
  return useQuery([{ id }],
    async () => {
      const { data, status } = await api.get(`usuarios/${id}`)
      return { data, status }
    },
    {
      enabled: id != 0 && id != undefined && id != null
    }
  )
}